<template>
  <div class="md-example-child md-example-child-popup md-example-child-popup-2">
  <md-popup
          class="inner-popup"
          v-model="dateSelectorShow"
          position="bottom"
          :mask-closable="false"
  >
    <md-popup-title-bar
            large-radius
            title="选择报名日期"
            ok-text="确定"
            cancel-text="取消"
            @confirm="confirm()"
            @cancel="cancel()"
    ></md-popup-title-bar>
    <div class="md-example-popup md-example-popup-align">
      <div class="md-scroll-view">
        <div class="ch-seat-item" v-for="day in course.left_days" :key="day.no">
          <md-radio :name="day.no" v-model="checked" :label="day.date" />
          <div class="seats">
            <div class="item" :class="{'sold':day.enroll >= index}" v-for="index in course.capacity"></div>
          </div>
        </div>
        <!--<div class="ch-seat-item">-->
          <!--<div class="seats">-->
            <!--<div class="item sold"></div>-->
            <!--<span>已选</span>-->
            <!--<div class="item"></div>-->
            <!--<span>可选</span>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>
  </md-popup>
  </div>
</template>

<script>
import {Popup, PopupTitleBar, ScrollView, Radio} from 'mand-mobile'
export default {
  name: 'enroll-date-selector',
  props:['dateSelectorShow', 'course'],
  components: {
      [Popup.name]: Popup,
      [ScrollView.name]: Popup,
      [PopupTitleBar.name]: PopupTitleBar,
      [Radio.name]: Radio,
  },
  data() {
      return {
          checked: '',
      };
  },
  methods: {
      confirm() {
          console.log(this.checked);
          if(this.checked === '') {
              this.$toast.failed('请选择要报名的日期');
              return;
          }
          const checked = this.course.left_days.filter(d => d.no == this.checked);
          this.$emit('dateChange', {...checked[0]});
          this.checked = '';
      },
      cancel() {
          this.checked = '';
          this.$emit('close');
      }
  }
}

</script>

<style lang="stylus">
  .md-example-child-popup-2
    float left
    width 100%
    .md-button
      margin-bottom 20px
    .md-popup-title-bar
      .md-popup-cancel
        .md-icon
          align-self flex-start
          margin-left 32px
    .md-example-popup
      position relative
      font-size font-minor-large
      background color-bg-base
      box-sizing border-box
      text-align center
      background-color #FFF
    .md-example-popup-align
      padding 0 40px
      .md-scroll-view
        height 500px
        overflow-y scroll
        p
          line-height 500px
          font-size 64px
          font-weight 200
          color #999
    .md-example-popup-top
      width 100%
      height 75px
      line-height 75px
      background #4a4c5b
      color #fff
      .md-icon
        position absolute
        right 20px
        top 50%
        transform translateY(-50%)
    .md-example-popup-bottom
      width 100%
      padding 0 0 150px
      p
        margin-bottom 100px
        font-size 64px
        font-weight 200
        color #999
    .md-example-popup-left, .md-example-popup-right
      height 100%
      padding 0 150px
      display flex
      align-items center999
</style>

